import cx from 'classnames'

export function TableFooterCell({
  children,
  align = 'left',
  className,
  colSpan
}: {
  children?: React.ReactNode
  align?: 'left' | 'center' | 'right'
  className?: string
  colSpan?: number
}) {
  return (
    <td className={cx('table-footer-cell', className)} colSpan={colSpan} align={align}>
      {children}
    </td>
  )
}
